import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendWhatsAppMessage } from 'services/whatsAppMessaging';
import {
  IWhatsAppMessage,
  ISendWhatsAppMessagePayload,
} from 'services/whatsAppMessaging/types';

export const ThunkSendWhatsAppMessage = createAsyncThunk<
  IWhatsAppMessage,
  { chatId: string; payload: ISendWhatsAppMessagePayload }
>('whatsAppMessaging/sendMessage', async ({ chatId, payload }) => {
  const r = await sendWhatsAppMessage(chatId, payload);
  return r.data;
});
